// Internal enum, used as selection value
enum ChangeUserPasswordMethod {
  // Immediately apply password - by overwriting current password
  Immediate = 'immediate',

  // Generate and send password reset link
  ResetLink = 'reset_link',
}

export default ChangeUserPasswordMethod